import React from "react";

const NomNomNom = () => {
  return <section>…</section>;
};

export default NomNomNom;
